<div class="max-h-[85vh] flex flex-col">
  <div mat-dialog-title class="flex justify-between items-center">
    <span i18n>Список деталей</span>
    <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="px-4 py-2 flex items-center space-x-4 border-b">
    <form [formGroup]="filterForm" class="flex items-center w-full space-x-4">
      <div class="flex w-full gap-4">
        <mat-form-field class="w-64">
          <mat-label i18n>Позиции деталей</mat-label>
          <mat-select formControlName="displayType">
            <mat-option [value]="DataDisplayType.Original" i18n>Оригинальные</mat-option>
            <mat-option [value]="DataDisplayType.Production" i18n>Производственные</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field floatLabel="always" class="w-auto">
          <mat-label i18n>Материал</mat-label>
          <mat-select i18n-placeholder placeholder="Все материалы" formControlName="materialName">
            <mat-option [value]="null" i18n>Все материалы</mat-option>
            <mat-option *ngFor="let material of materials$ | async" [value]="material.name">
              {{ material.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="flex w-full justify-end items-center space-x-2">
        <button
          mat-raised-button
          color="primary"
          class="mr-2"
          aria-label="Save changes"
          [disabled]="loading$ | async"
          (click)="saveChanges()">
          <span i18n>Сохранить</span>
        </button>
      </div>
    </form>
  </div>

  <div mat-dialog-content>
    <csl-data-grid
      class="h-full"
      [columns]="displayedColumns$ | async"
      [rows]="data$ | async"
      [loading]="loading$"
      [disableRowSelectionOnClick]="true"
      [disableColumnFilter]="true"
      [rowSelection]="false"
      [pageSizeOptions]="[25, 50, 100]"
      [hideFooterSelectedRowCount]="true">
    </csl-data-grid>
  </div>
</div>
